import React from 'react';
import { Box, Grid, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import LsChip from './LsChip';

const StyledCaseHeader = styled(Box)(({ theme }) => ({
    position: 'sticky',
    top: 0,
    zIndex: 1100,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `2px solid ${theme.palette.divider}`,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
    padding: '12px 24px',
}));

const DataItem = ({ label, value, color }) => (
    <Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
            {label}
        </Typography>
        <Typography variant="body1" fontWeight={600} color={color || 'text.primary'}>
            {value}
        </Typography>
    </Box>
);

const LsCaseHeader = ({
    caseId,
    debtorName,
    principal,
    outstanding,
    daysOverdue,
    statuses = [],
    actions,
    ...props
}) => {
    return (
        <StyledCaseHeader {...props}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={3}>
                    <Typography variant="h6" sx={{ mb: 0.5 }}>
                        {caseId}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {debtorName}
                    </Typography>
                </Grid>
                <Grid item xs={6} md={2}>
                    <DataItem label="Principal" value={principal} />
                </Grid>
                <Grid item xs={6} md={2}>
                    <DataItem label="Outstanding" value={outstanding} color="error.main" />
                </Grid>
                <Grid item xs={6} md={2}>
                    <DataItem label="Days Overdue" value={daysOverdue} />
                </Grid>
                <Grid item xs={6} md={3}>
                    <Stack direction="row" spacing={1} justifyContent="flex-end" flexWrap="wrap">
                        {statuses.map((status, index) => (
                            <LsChip key={index} label={status.label} status={status.type} />
                        ))}
                    </Stack>
                </Grid>
            </Grid>
            {actions && (
                <Box sx={{ mt: 1.5 }}>
                    {actions}
                </Box>
            )}
        </StyledCaseHeader>
    );
};

export default LsCaseHeader;